import { currencyOptions } from '../config';

export const getCurrencySymbol = (currencyCode = 'USD') => {
  const option = currencyOptions.find(c => c.value === currencyCode);
  return option?.symbol || '$';
};

export const formatCurrency = (amount, currencyCode = 'USD') => {
  const symbol = getCurrencySymbol(currencyCode);
  return `${symbol}${Math.round(amount).toLocaleString()}`;
};
